export const REVIEW_TYPE = {
  MONTHLY_PROGRESS_REVIEW: 'MONTHLY_PROGRESS_REVIEW',
  QUARTERLY_PERFORMANCE_REVIEW: 'QUARTERLY_PERFORMANCE_REVIEW',
  PROBATION_PERIOD_END: 'PROBATION_PERIOD_END',
  FIRST_YEAR_PERFORMANCE_REVIEW: 'FIRST_YEAR_PERFORMANCE_REVIEW',
};

export const REVIEW_TYPE_LABELS = {
  MONTHLY_PROGRESS_REVIEW: 'Monthly Progress',
  QUARTERLY_PERFORMANCE_REVIEW: 'Quarterly Performance',
  PROBATION_PERIOD_END: 'Probation End',
  FIRST_YEAR_PERFORMANCE_REVIEW: 'First Year Review',
};

// Only these two types show a milestone value
export const REVIEW_TYPE_HAS_MILESTONE = [
  REVIEW_TYPE.MONTHLY_PROGRESS_REVIEW,
  REVIEW_TYPE.QUARTERLY_PERFORMANCE_REVIEW,
];

export const REVIEW_STATUS = {
  PENDING: 'PENDING',
  EMPLOYEE_SUBMITTED: 'EMPLOYEE_SUBMITTED',
  COMPLETED: 'COMPLETED',
  SKIPPED: 'SKIPPED',
};

export const REVIEW_STATUS_OPTIONS = [
  { label: 'All Status', value: '' },
  { label: 'Pending', value: 'PENDING' },
  { label: 'Employee Submitted', value: 'EMPLOYEE_SUBMITTED' },
  { label: 'Completed', value: 'COMPLETED' },
  { label: 'Skipped', value: 'SKIPPED' },
];

export const REVIEW_TYPE_TABS = [
  { label: 'Monthly Progress', value: REVIEW_TYPE.MONTHLY_PROGRESS_REVIEW },
  { label: 'Quarterly Performance', value: REVIEW_TYPE.QUARTERLY_PERFORMANCE_REVIEW },
  { label: 'Probation End', value: REVIEW_TYPE.PROBATION_PERIOD_END },
  { label: 'First Year Review', value: REVIEW_TYPE.FIRST_YEAR_PERFORMANCE_REVIEW },
];
